export interface OffsetLimit {
    offset: number
    limit: number
}

export function toQueryParameters({offset, limit}: OffsetLimit) {
    return {
        offset: offset.toString(),
        limit: limit.toString(),
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/OffsetLimit.ts